/* specifically target IE11 */
/* controlled focus outline */
/**
 * AGL BRAND TOKENS VERSION 0.2.45
 * GENERATED BY STYLE DICTIONARY
 * DO NOT EDIT THIS FILE DIRECTLY
 */
/* usage
.selector {
  color: red;

  @include breakpoint(sm) {
    color: blue;
  }
}
*/
:host {
  display: block;
}

.dls-using-mouse {
  box-shadow: none !important;
}

:host {
  display: flex;
  flex-direction: column;
}
:host .hint-text {
  color: var(--colors-component-form-type-hint);
  display: block;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  font-size: 0.875rem;
  width: auto;
}
:host .alert-text-container {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  font-size: 0.875rem;
  margin-top: 8px;
  display: flex;
}
:host .alert-text-container dls-icon {
  margin: 2px 0 2px 2px;
}
:host .alert-text-container .alert-text--error {
  color: var(--colors-component-form-type-validation-error);
  margin: 1px 0 0 0;
}
:host .alert-text-container .alert-text--success {
  color: var(--colors-component-form-type-validation-success);
  margin: 1px 0 0 0;
}
:host label {
  color: var(--colors-component-form-type-label);
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  font-size: 1rem;
}
:host .dls-dropdown {
  appearance: none;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  font-size: 1rem;
  background-color: var(--colors-component-dropdown-background);
  border-radius: 4px;
  border: 1px solid var(--colors-component-dropdown-border-enabled);
  padding: 11px 15px;
  color: var(--colors-component-form-type-input);
  margin-top: 8px;
  text-overflow: ellipsis;
  background-repeat: no-repeat;
  background-position: right 11px center;
  padding-right: 48px;
  background-size: 24px;
}
:host .dls-dropdown:focus {
  outline: none;
  box-shadow: 0 0 1px 3px var(--colors-interactive-focus-ring, var(--colors-component-focus));
  border-color: var(--colors-component-dropdown-border-active);
}
:host .dls-dropdown:active {
  border-color: var(--colors-component-dropdown-border-active);
}
:host .dls-dropdown:hover:not(:focus) {
  border-color: var(--colors-component-dropdown-border-hover);
}
:host .dls-dropdown--error {
  border-color: var(--colors-component-dropdown-border-error) !important;
}
:host .dls-top-margin--none {
  margin-top: 0;
}
:host .dls-top-margin--space00 {
  margin-top: 4px;
}
:host .dls-top-margin--space01 {
  margin-top: 8px;
}
:host .dls-top-margin--space02 {
  margin-top: 16px;
}
:host .dls-top-margin--space03 {
  margin-top: 24px;
}
:host .dls-top-margin--space04 {
  margin-top: 32px;
}
:host .dls-top-margin--space05 {
  margin-top: 40px;
}
:host .dls-top-margin--space06 {
  margin-top: 48px;
}